"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestAvailability = void 0;
exports.instanceOfInterestAvailability = instanceOfInterestAvailability;
exports.InterestAvailabilityFromJSON = InterestAvailabilityFromJSON;
exports.InterestAvailabilityFromJSONTyped = InterestAvailabilityFromJSONTyped;
exports.InterestAvailabilityToJSON = InterestAvailabilityToJSON;
exports.InterestAvailabilityToJSONTyped = InterestAvailabilityToJSONTyped;
/**
 *
 * @export
 */
exports.InterestAvailability = {
    Asap: 'ASAP',
    Within90Days: 'WITHIN_90_DAYS',
    Other: 'OTHER'
};
function instanceOfInterestAvailability(value) {
    for (const key in exports.InterestAvailability) {
        if (Object.prototype.hasOwnProperty.call(exports.InterestAvailability, key)) {
            if (exports.InterestAvailability[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function InterestAvailabilityFromJSON(json) {
    return InterestAvailabilityFromJSONTyped(json, false);
}
function InterestAvailabilityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function InterestAvailabilityToJSON(value) {
    return value;
}
function InterestAvailabilityToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=InterestAvailability.js.map